import React, { useState, useEffect, useRef} from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { collection, getDocs} from "firebase/firestore";
import { database } from "../config/firebaseConfig";
import AlertOnLoading from '../components/AlertOnLoading';
import { LazyLoadImage } from 'react-lazy-load-image-component';



function AboutUsPage() {

    const WAIT_TIME = 1000; //Waits for 2s
    const notInitialRender = useRef(false);

    const [newData, setNewData] = useState(true);

    const [aboutUs, setAboutUs] = useState(null);
    const [workers, setWorkers] = useState(null);

    useEffect(() => {
        if (notInitialRender.current && newData){
            AlertOnLoading(WAIT_TIME+100);
            
        } else {
            notInitialRender.current = true;
        }
    
        const interval = setInterval(() => { //Autorize re-render
            if (newData) {
                const aboutUsRef = collection(database, "aboutUs");
                const workersRef = collection(database, 'workers');
                
                const getAboutUs = async() => {
                    const data = await getDocs(aboutUsRef);
                    setAboutUs(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }

                const getWorkers = async() => {
                    const workersData = await getDocs(workersRef);
                    setWorkers(workersData.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }
                console.log("Actualizo");
                getAboutUs();
                getWorkers();
                setNewData(!newData);
            }
        }, WAIT_TIME);
        return () => clearInterval(interval);
    }, [aboutUs, workers, newData])



    return(
     <div>
        <Navbar activePage={"/AboutUs"} />
        <div className='w-full h-navbar-mobile sm:h-navbar'></div>

        {aboutUs? aboutUs.map((us) => (
        <div key={us.id} className='w-full h-auto flex flex-col space-y-10'>

            <div className='w-full h-auto bg-white'>
                <div className='flex items-center justify-center flex-col w-full h-28 bg-about-us-banner lg:py-8'>
                    <h2 className='text-xl font-bold text-background lg:text-2xl xl:text-3xl'>Conózcanos</h2>
                </div>

                {/* Cuadro de conózcanos */}
                <div className='px-5 flex justify-center my-20 w-full'>
                    <div className='flex justify-center shadow-lg flex-col p-5 w-96 h-auto bg-white lg:py-8 max-w-table-web lg:w-full md:w-10/12'>
                        <div className='text-justify h-auto'>
                            <p className='text-black text-md h-auto leading-7 lg:text-lg'>{us.description}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/*Este es col para mobile */}
            <div className='w-full h-auto bg-white my-6 flex flex-col sm:hidden'>
                <div className='w-full h-96 bg-white flex flex-col justify-center items-center'>
                    <div className='my-6 w-72 h-12 bg-about-blue flex justify-center items-center'>
                        <h2 className='text-xl font-bold text-background'>Misión</h2>
                    </div>

                    <div className='w-72 h-auto bg-white flex justify-center text-center shadow-lg'>
                        <p className='text-black text-md leading-7 lg:text-lg'>{us.mission}</p>
                    </div>
                </div>

                <div className='w-full h-96 bg-white flex flex-col justify-center items-center'>
                    <div className='my-6 w-72 h-12 bg-about-blue flex justify-center items-center'>
                        <h2 className='text-xl font-bold text-background'>Visión</h2>
                    </div>

                    <div className='w-72 h-auto bg-white flex justify-center text-center shadow-lg'>
                        <p className='text-black text-md leading-7 lg:text-lg'>{us.vision}</p>
                    </div>
                </div>
            </div>

            
            {/*Este es row para Desktop */}
            <div className='hidden w-full h-auto bg-white my-6 sm:flex flex-row items-center'>
                <div className='w-full h-96 bg-white flex flex-col justify-center items-center'>
                    <div className='my-6 w-72 h-12 bg-about-blue flex justify-center items-center'>
                        <h2 className='text-xl font-bold text-background'>Misión</h2>
                    </div>

                    <div className='w-72 h-auto bg-white flex justify-center text-center shadow-lg'>
                        <p className='text-black text-md leading-7 lg:text-lg'>{us.mission}</p>
                    </div>
                </div>

                <div className='w-full h-96 bg-white flex flex-col justify-center items-center'>
                    <div className='my-6 w-72 h-12 bg-about-blue flex justify-center items-center '>
                        <h2 className='text-xl font-bold text-background'>Visión</h2>
                    </div>

                    <div className='w-72 h-auto bg-white flex justify-center text-center shadow-lg'>
                        <p className='text-black text-md leading-7 lg:text-lg'>{us.vision}</p>
                    </div>
                </div>
            </div>


            <div className='w-full h-auto bg-white'>
                <div className='px-4 py-6 flex flex-col w-full h-auto bg-white lg:py-8'>
                    <h2 className='lg:text-xl'>Colaboradores</h2>
                    <span className='lg:w-80 w-48 border border-primary-100'></span>

                    <div className='w-full h-auto flex flex-col md:grid md:grid-cols-3 md:gap-4 md:place-content-center gap-8 my-10 items-center justify-center text-center'>
                        {workers?.map((worker) => (    
                        <div key={worker.id} className='w-full h-auto flex flex-col items-center'>
                            <h2 className='text-black font-semibold text-base lg:text-lg px-5 h-14 flex justify-center items-center'>{worker.position}</h2>

                            <div className='w-52 h-52 lg:w-60 lg:h-60 my-2 rounded-full bg-primary-100 flex items-center justify-center'>
                                <div className='w-48 h-48 lg:w-56 lg:h-56 rounded-full bg-black overflow-hidden'>
                                    <LazyLoadImage src={worker.image} className='w-full h-auto object-cover rounded-full'
                                            alt=''></LazyLoadImage>
                                </div>
                            </div>

                            <span className='lg:w-72 md:w-52 w-64 border border-slate-400'></span>

                            <div className='w-64 lg:w-64 h-auto text-center my-2 lg:mt-4 font-thin lg:text-lg'>{worker.name}</div>

                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
        ))
        :
        <div className='w-full bg-white flex h-auto justify-center items-center text-4xl text-primary-100 space-x-1 min-h-screen'>
            <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                <path clipRule='evenodd'
                    d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                    fill='currentColor' fillRule='evenodd' />
            </svg>
            <div>
                Cargando...
            </div>
        </div>
        }
        <Footer />
     </div>   
    )
}

export default AboutUsPage